import CollectionCreatePage from "./pages/CollectionCreatePage";
import CollectionListPage from "./pages/CollectionListPage";
import CollectionDetailPage from "./pages/CollectionDetailPage";

export const collectionRoutes = (prefix = "collections") => [
  {
    name: "CollectionCreatePage",
    path: `${prefix}/create`,
    component: CollectionCreatePage
  },
  {
    name: "CollectionDetailPage",
    path: `${prefix}/:id`,
    component: CollectionDetailPage
  },
  { name: "CollectionListPage", path: prefix, component: CollectionListPage }
];
